import React, { useState, useEffect, useRef } from 'react';
import { IoCloseSharp } from "react-icons/io5";
import { motion } from 'framer-motion';
import ColorsMain from "../../colors/ColorsMain";
import CustomSpinner from "../../components/spinners/CustomSpinner";

const Create2FA = ({
    setModal,
    modal,
    otp,
    setOtp,
    loadingOTP,
    errorOTP,
    setErrorOTP,
    setConfirmPurchase,
    setActiveConfimPurchase
}) => {
    const [loading, setLoading] = useState(false);
    const [valueOTP, setValueOTP] = useState(false);
    const firstInputRef = useRef(null); // Referencia para el primer input

    // Enfocar el primer input cuando el modal se abre
    useEffect(() => {
        if (modal && firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, [modal]);

    const OnClose = () => {
        setOtp(["", "", "", "", "", ""]);
        setConfirmPurchase(false);
        setModal(false);
        setErrorOTP("");
        setActiveConfimPurchase(false);
        setConfirmPurchase(false);
    };

    const modalVariants = {
        hidden: { scale: 0, opacity: 0 },
        visible: { scale: 1, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
        exit: { scale: 0.8, opacity: 0, transition: { duration: 0.5, ease: "easeInOut" } },
    };

    const handleChange = (value, index) => {
        const newOtp = [...otp];
        newOtp[index] = value.slice(-1); // Solo permite un carácter
        setOtp(newOtp);

        // Mueve el foco al siguiente input si hay un valor
        if (value && index < 5) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }

        // Si todos los dígitos están llenos, puedes hacer algo (como enviar el OTP)
        if (newOtp.every((digit) => digit !== '')) {
            setValueOTP(newOtp);
            // Aquí puedes agregar la lógica para manejar el OTP completo
        }
    };

    const handleKeyDown = (event, index) => {
        if (event.key === 'Backspace') {
            if (otp[index] === '') {
                // Si el campo actual está vacío, retrocede al campo anterior
                if (index > 0) {
                    const newOtp = [...otp];
                    newOtp[index - 1] = ''; // Borra el dígito del campo anterior
                    setOtp(newOtp);
                    document.getElementById(`otp-input-${index - 1}`).focus(); // Mueve el foco al campo anterior
                }
            } else {
                // Si hay un valor en el campo actual, simplemente lo borra
                const newOtp = [...otp];
                newOtp[index] = ''; // Borra el dígito del campo actual
                setOtp(newOtp);
            }
        }
    };

    const handlePaste = (event) => {
        const pastedData = event.clipboardData.getData('Text');
        const newOtp = pastedData.split('').slice(0, 6); // Toma solo los primeros 6 caracteres

        // Rellena el estado del OTP y mueve el foco al último input
        setOtp(newOtp);
        setValueOTP(newOtp);
        newOtp.forEach((digit, index) => {
            if (index < 6) {
                document.getElementById(`otp-input-${index}`).value = digit; // Rellena el input
            }
        });
        document.getElementById(`otp-input-5`).focus(); // Mueve el foco al último input
        event.preventDefault(); // Evita el comportamiento predeterminado de pegar
    };

    return (
        <>
            {modal && (
                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50">
                    <motion.div
                        className="bg-[#26262D] rounded-lg shadow-lg w-[90%] max-w-2xl h-auto flex flex-col justify-between overflow-hidden"
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <div className="p-6">
                            <div className="w-full flex flex-row justify-between">
                                <p className="text-lg font-semibold text-white">
                                    {'Verificación de 2 pasos'}
                                </p>
                                <IoCloseSharp
                                    size={25}
                                    color={"#b7b7b9"}
                                    onClick={() => OnClose()}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        {/* Contenido dinámico del modal */}
                        <div className="flex-grow px-6">
                            <motion.div
                                className="bg-[#26262D]"
                                key="step2"
                                variants={modalVariants}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                                <div className='w-full h-[41vh] mb-4 rounded-[12px] gap-2 flex flex-col bg-[#2b2b33] p-6'>
                                    {!loadingOTP && <p className='text-xl mb-2'>Ingresa el código de un solo uso</p>}
                                    {!loadingOTP && (
                                        <p className='text-[#8A8A8E]'>
                                            Se ha habilitado la verificación en dos pasos para esta cuenta.
                                            Ingrese el código de un solo uso que aparece en el vínculo de la aplicación de autenticación:
                                        </p>
                                    )}
                                    <div className='flex flex-row justify-center items-center mt-6'>
                                        {!loadingOTP && otp.map((digit, index) => (
                                            <input
                                                key={index}
                                                id={`otp-input-${index}`}
                                                ref={index === 0 ? firstInputRef : null} // Referencia para el primer input
                                                type="text"
                                                value={digit}
                                                onChange={(e) => handleChange(e.target.value, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                onPaste={handlePaste}
                                                style={{
                                                    ...styles.input,
                                                    border: `1px solid ${ColorsMain.borderGray}`,
                                                }}
                                                onBlur={(e) =>
                                                    (e.target.style.border = `1px solid ${ColorsMain.borderGray}`)
                                                }
                                                onFocus={(e) =>
                                                    (e.target.style.border = `1px solid ${ColorsMain.graywhite}`)
                                                }
                                                maxLength={1}
                                            />
                                        ))}
                                    </div>

                                    {loadingOTP && <CustomSpinner />}
                                    {<p className='text-[#e4847f] text-center mt-4'>{errorOTP}</p>}
                                </div>
                            </motion.div>
                        </div>
                    </motion.div>
                </div>
            )}
        </>
    );
};

const styles = {
    input: {
        width: "62px",
        height: "64px",
        fontSize: 32,
        marginRight: "16px",
        textAlign: "center",
        borderRadius: "5px",
        color: ColorsMain.texttMain,
        background: ColorsMain.bgMain,
    },
};

export default Create2FA;